export default __webpack_public_path__ + "0d0f60884a847418ca7961bcdd093823.svg";